import { KeyMessageGroupApi } from '../../../api/ai/model/key-message-group-api.';
import { Mention } from '../../Mentions/models/mention';

export class CoverageInsightConfigModel {
    keyMessageGroups: KeyMessageGroupApi[] = [];
    mentions: Mention[] = [];

    constructor(keyMessageGroups: KeyMessageGroupApi[], mentions: Mention[]) {
        this.keyMessageGroups = keyMessageGroups;
        this.mentions = mentions;
    }
}
